import Maybe from 'graphql/tsutils/Maybe';
import replace from 'lodash/replace';

export const resizeImageW = (imageUrl: Maybe<string>, width: number, removeRotation: boolean = false) => {
  if (!imageUrl) return undefined;
  const [path, query] = imageUrl.split('?');

  let newPath = path;
  if (removeRotation) {
    newPath = replace(path, new RegExp(/rt_([0-9]{1,3}|auto)-/), '');
  }

  const joinChar = imageUrl.match('~') ? '-' : '~';

  let rotationAuto = removeRotation ? '' : 'rt_auto-';

  let url = `${newPath}${joinChar}${rotationAuto}rs_${width}.h`;
  if (query) {
    url = url + `?${query}`;
  }

  return url;
};

export const resizeImagePortrait = (imageUrl: Maybe<string>, width: number) => {
  if (!imageUrl) return undefined;
  const [originalPath, query] = imageUrl.split('?');
  const path = originalPath.replace('rt_0', 'rt_auto');

  const joinChar = imageUrl.match('~') ? '-' : '~';
  let url = `${path}${joinChar}-rs_w.${width}`;
  if (query) {
    url = url + `?${query}`;
  }

  return url;
};
